import { ReactComponent as IconStatusExclmation } from '@/assets/svgs/icon-status-exclamation.svg'
import { ReactComponent as IconStatusTick } from '@/assets/svgs/icon-status-tick.svg'
import Button from '@/components/Button'
import CardUseCase from '@/components/CardUseCase'
import Toast from '@/components/Toast'
import CardConfigure from "@/componentsDS/Modal/CardConfigure"
import Modal from "@/componentsDS/Modal/Modal"
import { textTypes } from '@/constants/configuration/dex-locale/dex-locale'
import { useBuildex } from '@/hooks/use-buildex/index'
import useModal from '@/hooks/use-modal'
import usePage from '@/hooks/use-page'
import useProfile from '@/hooks/use-participant-profile'
import useToast from '@/hooks/use-toast'
import useUseCases from '@/hooks/use-use-cases'
import { useNavigate } from '@/lib/router-dom'
import { fetchDexText } from '@/utils/fetch-dex-text'
import { getDexConfig } from '@/utils/get-dex-config'
import { getEnvAndDex } from '@/utils/get-env-and-dex'
import rem from '@/utils/rem'
import classname from 'classnames'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

const Page = () => {
	/*=================================================
		General
	/================================================*/

	const user = useSelector(state => state.auth.user)
	// const profile = useSelector(state => state.auth.profile)
	const userType = useSelector(state => state.auth.userType)

	const { dex } = getEnvAndDex();

	const statuses = {
		approved: "APPROVED",
		rejected: "REJECTED",
		revoked: "REVOKED",
		pending: "PENDING",
		notEnrolled: "NOT_ENROLLED",
		signdsa: "DSA_REQUESTED",
		informationRequired: "INFO_REQUESTED"
	}

	const toastType = {
		success: "success",
		error: "error"
	}

	const { breadcrumbsItems } = usePage({ title: 'Home', breadcrumbs: ['Home'] })
	const { goTo } = useNavigate()

	const [requestType, setRequestType] = useState()

	/*=================================================
		API
	/================================================*/

	const { toastList, addToastMessage } = useToast()

	const { items: useCasesItems, fetch: fetchUseCases, error: errorUseCase } = useUseCases()
	const { currentItem: currentProfile, fetch: fetchProfile, error: errorProfile } = useProfile()

	useEffect(() => {
		fetchUseCases()
		fetchProfile()
	}, [])

	/*=================================================
		Use Cases List
	/================================================*/

	const UseCasesList = ({ itemData }) => {
		if (!Array.isArray(itemData)) {
			return ""
		}

		let size = 0
		if (currentProfile?.organization?.status === statuses.notEnrolled) {
			size = 3
		}

		if (currentProfile?.organization?.status !== statuses.notEnrolled) {
			size = 2
		}

		const list = itemData.slice(0, size).map((item, index) => {
			return (
				<div className="grid__col" key={index}>
					<CardUseCase
						id={item.id}
						title={item.name}
						image={item.image}
						description={item.description}
						status={currentProfile?.organization?.status}
						noOfDataElements={item.dataElements.length}
						noOfParticipants={item.participants}
						role={userType}
					/>
				</div>
			)
		})

		return list
	}

	/*=================================================
		Modal
	/================================================*/

	const { visible: visibleConfirmation, show: showConfirmation, hide: hideConfirmation } = useModal()

	/*=================================================
		Navigation
	/================================================*/

	const goToUseCase = (item) => {
		goTo(`/use-cases`)
	}

	const goToViewApplication = () => {
		goTo(`/use-cases/view/sgtradex`)
	}

	/*=================================================
		Additional Function
	/================================================*/

	const exploreUseCaseClass = classname({
		'grid__container': true,
		'grid__container--max-width': currentProfile?.organization?.status !== statuses.notEnrolled
	})

	/*=================================================
		Stepper Status
	/================================================*/

	const StepperStatus = ({ status }) => {
		return (
			<div className="status-stepper">
				<div className="status-stepper__item status-stepper__item__active status-stepper__item__active--success">
					<div className="status-stepper__item__left">
						<IconStatusTick />
					</div>
					<div className="status-stepper__item__right">
						<div className="status-stepper__item__top">
							Application Submitted
						</div>
						<div className="status-stepper__item__bottom">
							<span
								className='link'
								onClick={() => goToViewApplication()}
							>View application</span>
						</div>
					</div>
				</div>

				{status === statuses.signdsa && (
					<div className="status-stepper__item status-stepper__item__active status-stepper__item__active--warning">
						<div className="status-stepper__item__left">
							<IconStatusExclmation />
						</div>
						<div className="status-stepper__item__right">
							<div className="status-stepper__item__top">
								Pending Action
							</div>
							<div className="status-stepper__item__bottom">
								We’ve sent a Data Sharing Agreement to your appointee to review and sign via Docusign. Have them check their inbox to proceed.
							</div>
						</div>
					</div>
				)}

				{status === statuses.informationRequired && (
					<div className="status-stepper__item status-stepper__item__active status-stepper__item__active--warning">
						<StatusStepperItemLeft top={"Information Required"} bottom={"We need a bit more information from you to process your application."} />
					</div>
				)}

				{status === statuses.rejected && (
					<div className="status-stepper__item status-stepper__item__active--error">
						<StatusStepperItemLeft top={"Application Rejected"} bottom={"Sorry, we had to reject your application. "} />
					</div>
				)}

				{status !== statuses.rejected && (
					<StatusStepperItem>
						<div className="status-stepper__item__left"></div>
						<div className="status-stepper__item__right">
							<div className="status-stepper__item__top">
								Start Exchanging!
							</div>
						</div>
					</StatusStepperItem>
				)}

				{status !== statuses.signdsa && status !== statuses.rejected && (
					<StatusStepperItem>
						<div className="status-stepper__item__left">
							<IconStatusTick />
						</div>
						<div className="status-stepper__item__right">
							Sign Data Sharing Agreement
						</div>
					</StatusStepperItem>
				)}

			</div>
		)

	}

	const StatusStepperItem = ({ children }) => {
		return (
			<div className="status-stepper__item">
				{children}
			</div>
		)
	}

	const StatusStepperItemLeft = (props) => {
		const { top, bottom } = props
		return (
			<>
				<div className="status-stepper__item__left">
					<IconStatusExclmation />
				</div>
				<div className="status-stepper__item__right">
					<div className="status-stepper__item__top">
						{top}
					</div>
					<div className="status-stepper__item__bottom">
						{bottom}<br />
						<span className='link' onClick={() => showConfirmation()}>View details</span>
					</div>
				</div>
			</>
		)
	}

	const CardWrapper = () => {
		return (
			<CardConfigure style={{ maxWidth: rem(600), position: 'relative', top: rem(40) }}>
				<CardWrapperHeader />
				<CardWrapperBody />
			</CardConfigure>
		)
	}

	const CardWrapperHeader = () => {
		return (
			<CardConfigure.Header>
				<CardConfigure.Header.Title>
				<div className="card-configure__header__left">
						<div className="card-configure__title">
							<div className="card-configure__title__right">
								<div className="card-configure__title__right__top">
								Details
								</div>
							</div>
						</div>
					</div>
				</CardConfigure.Header.Title>
			</CardConfigure.Header>
		)
	}

	const CardWrapperBody = () => {
		return (
			<CardConfigure.Body>
				<CardConfigure.Body.Col>
					{currentProfile?.organization?.adminRequest?.comment}
				</CardConfigure.Body.Col>
			</CardConfigure.Body>
		)
	}

	const { dexName, tagline } = getDexConfig(dex);

	const isBuildex = useBuildex()

	return (
		<>
			<div className="title-header">
				<div className="title-header__left">
					<div className="title-header__title">
						Welcome
					</div>
				</div>
			</div>

			<div className="participant-home__container">
				<div className="participant-home__card participant-home__card--gfx">
					<span>{isBuildex ? dexName : fetchDexText(dex, textTypes.DEX_NAME) } DATA HIGHWAY</span>

					<div className="participant-home__counter-container">
						<span className="participant-home__title">
							{isBuildex ? tagline : fetchDexText(dex, textTypes.TAGLINE_TEXT)}
						</span>
					</div>
				</div>

				<div className="participant-home__content">
					<div className="participant-home">

						<div className={exploreUseCaseClass}>
							<div className="grid__title">
								Explore Use Cases
							</div>

							<div className="grid">
								<div className="grid__cols">
									<UseCasesList itemData={useCasesItems} />
									<div className='grid__col'>
										<div className="card card--height card--purple">
											<div className="card__explore">
												<img src="./explore-use-case.png" alt="" />
												<Button text="Explore Other Use Case" id="navigation-use-cases-tab" submit={() => goToUseCase()} ghost />
											</div>

										</div>
									</div>
								</div>
							</div>
						</div>

						{currentProfile?.organization?.status !== statuses.notEnrolled && (
							<div className="grid__container">
								<div className="grid__title">
									Enrollment Status
								</div>
								<div className="grid">
									<div className="grid__cols">
										<div className='grid__col'>
											<div className="card ">
												<StepperStatus
													status={currentProfile?.organization?.status}
												/>
												<div className="card__content__footer card__content__footer--status">
													For queries reach us at <a className='link' href="mailto:support@sgtradex.com">support@sgtradex.com</a>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						)}
					</div>
				</div>
			</div>

			<Modal visible={visibleConfirmation} variant='medium' close={hideConfirmation}>
				<CardWrapper />
			</Modal>

			<Toast toastList={toastList} />
		</>
	)
}

export default Page
